import _ from "underscore";

("use strict");

const ObservingList = {
	setAuxLists: () => {
		_.each(Portal.Current.Collections.observingLists, (observingList) => {
			observingList.auxLists = _.filter(
				Portal.Current.Collections.observingListAuxs,
				function (observingListAux) {
					return observingListAux.get("observingList")
						? observingListAux.get("observingList").id === this.id
						: false;
				},
				observingList,
			);
		});
	},
};

export default ObservingList;
